<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else>
            <headline-container :headline="company.data.name" :breadcrumbs="breadcrumbs">
                <div class="btn-group">
                    <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-cogs"></i> Company Functions <span class="caret"></span>
                    </button>

                    <ul class="dropdown-menu">
                        <li>
                            <router-link :to="'/companies/' + companyId + '/people/create'">
                                <i class="fa fa-plus"></i> Create Person
                            </router-link>
                        </li>
                        
                        <li>
                            <router-link :to="'/companies/' + companyId + '/orders/create'">
                                <i class="fa fa-plus"></i> Create Order
                            </router-link>
                        </li>
                        
                        <li>
                            <router-link :to="'/companies/' + companyId + '/subscriptions/create'">
                                <i class="fa fa-plus"></i> Create Subscription
                            </router-link>
                        </li>

                        <li>
                            <router-link :to="'/companies/' + companyId + '/opportunities/create'">
                                <i class="fa fa-plus"></i> Create Opportunity
                            </router-link>
                        </li>

                        <li>
                            <router-link :to="'/companies/' + companyId + '/order-confirmations/create'">
                                <i class="fa fa-plus"></i> Create Order Confirmation
                            </router-link>
                        </li>

                        <li role="separator" class="divider"></li>

                        <li>
                            <router-link :to="'/companies/' + companyId + '/order-payments/create'">
                                <i class="fa fa-dollar-sign"></i> Invoice Orders
                            </router-link>
                        </li>
                        
                        <li v-if="hasPermission('admin')" role="separator" class="divider"></li>

                        <li v-if="hasPermission('admin')">
                            <a @click.prevent="destroy">
                                <i class="fa fa-trash"></i> Delete
                            </a>
                        </li>
                    </ul>
                </div>
            </headline-container>

            <sub-menu :company="company"></sub-menu>

          <router-view v-model="company"></router-view>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import HeadlineContainer from '@/components/Layout/HeadlineContainer'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import Permissions from '@/mixins/Permissions'
    import SubMenu from '@/pages/Companies/Companies/Edit/SubMenu'

    export default {
        components: {HeadlineContainer, LoadingContainer, SubMenu},

        mixins: [Load, Permissions],

        props: ['companyId'],

        data() {
            return {
                company: null
            }
        },

        mounted() {
            this.load({company: '/api/v1/companies/' + this.companyId})
        },
        
        watch: {
            companyId() {
                this.load({company: '/api/v1/companies/' + this.companyId})
            }
        },

        computed: {
            breadcrumbs() {
                return [{url: '/companies', text: 'Companies'}, {text: this.company.data.name}]
            }
        },

        methods: {
            destroy() {
                modal.confirm('Are you sure that you want to delete the company?', () => {
                    http.delete('/api/v2/companies/' + this.company.data.id)
                        .then(() => {
                            notify.success('The company was deleted')

                            this.$router.push('/companies')
                        })
                })
            }
        }
    }
</script>
